import { DocumentReceiptEntity } from '../../../../generated-api';

export function isEmptyReceipt(receipt: DocumentReceiptEntity): boolean {
  if (!receipt.payment_date && !receipt.payee?.[0] && !receipt.business_number) {
    return true;
  }
  return false;
}
